import "./Spinner.scss";
const logoSrc = process.env.PUBLIC_URL + "/images/USMB-logo.png";

export default function Spinner(props) {
    return (<img className={"spinner-image"} alt={"Spinner"} src={logoSrc}/>)
}